<template>
  <sea-page-content
    ref="list"
    :fetchList="fetchList"
    :resetList="resetList"
    toolbar
    searchPanel
    in-tab
    hide-data-pub
    pulsanteAggiorna
    pulsanteCronologia
    historyDir="dossier"
    @docsPubblicatiClick="pubblicati = true"
    @docsNonPubblicatiClick="pubblicati = false"
    @resetPubblicati="pubblicati = null"
    :beforeFetchList="resetTags"
    search-panel
    pulsante-aggiorna
    pulsante-cronologia
    pulsanteEliminaFascicolo
  >
    <template v-slot:table="{ attrs, height }">
      <v-data-table
        v-model="attrs.selected"
        v-bind="attrs"
        :height="height"
        :headers="headers"
        :items="filteredItems"
        sort-by="dataScadenza"
        show-expand
        single-expand
        single-select
        dense
        show-select
        @click:row="rowClick"
        @update:sort-by="sortBy"
      >
        <template v-slot:expanded-item="{ _, item }">
          <td class="expanded-row" colspan="2"></td>
          <td class="expanded-row">
            <table class="detail">
              <tr v-for="doc in item.documenti" :key="doc.id">
                <td class="text-start text-little-2">
                  {{ doc.tags }}
                </td>
              </tr>
            </table>
          </td>
          <td class="expanded-row">
            <table class="detail">
              <tr v-for="doc in item.documenti" :key="doc.id">
                <td class="text-start text-little-2">
                  {{ doc.descrizione }}
                </td>
              </tr>
            </table>
          </td>
          <td class="expanded-row">
            <table class="detail">
              <tr v-for="doc in item.documenti" :key="doc.id">
                <td class="text-start text-little-2">
                  {{ doc.dataScadenza | dateFormat }}
                </td>
              </tr>
            </table>
          </td>
          <td class="expanded-row">
            <table class="detail">
              <tr v-for="doc in item.documenti" :key="doc.id">
                <td class="text-center text-little-2">
                  <check-icon :checked="doc.visibile"></check-icon>
                </td>
              </tr>
            </table>
          </td>
          <td class="expanded-row">
            <table class="detail">
              <tr v-for="doc in item.documenti" :key="doc.id">
                <td class="text-start text-little-2">
                  {{ doc.dataConsegna | dateFormat }}
                </td>
              </tr>
            </table>
          </td>
          <td class="expanded-row">
            <table class="detail">
              <tr v-for="doc in item.documenti" :key="doc.id">
                <td class="text-center text-little-2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <sea-avatar v-bind="attrs" v-on="on">
                        {{
                          getIniziali({
                            nome: doc.createdByFirstName,
                            cognome: doc.createdByLastName,
                          })
                        }}
                      </sea-avatar>
                    </template>
                    {{ doc.createdByFirstName }} {{ doc.createdByLastName }}
                  </v-tooltip>
                </td>
              </tr>
            </table>
          </td>
          <td class="expanded-row">
            <table class="detail">
              <tr v-for="doc in item.documenti" :key="doc.id">
                <td class="text-center text-little-2">
                  <stato-lettura :stato="doc.statoLettura"></stato-lettura>
                </td>
              </tr>
            </table>
          </td>
          <td class="expanded-row">
            <table class="detail">
              <tr v-for="doc in item.documenti" :key="doc.id">
                <td class="text-start text-little-2">
                  <v-btn
                    elevation="2"
                    rounded
                    x-small
                    @click.stop="download(doc)"
                    :color="colors.primarycolor"
                    dark
                  >
                    APRI
                    <v-icon right>mdi-open-in-new</v-icon>
                  </v-btn>
                </td>
              </tr>
            </table>
          </td>
        </template>

        <template v-slot:header.tags="{ props, on }">
          <v-menu
            offset-y
            :close-on-content-click="false"
            v-bind="props"
            v-on="on"
          >
            <template v-slot:activator="{ on, attrs }">
              Tag
              <v-icon v-bind="attrs" v-on="on"> mdi-menu-down </v-icon>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-action>
                  <v-checkbox
                    @click="selectedTags = []"
                    v-model="allTags"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-title>Tutti</v-list-item-title>
              </v-list-item>
              <v-list-item v-for="(tag, index) in tags" :key="index">
                <v-list-item-action>
                  <v-checkbox
                    @click="addRemove(tag.text)"
                    v-model="tag.active"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-title>{{ tag.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:item.visualizza="{ item }">
          <v-btn
            elevation="2"
            rounded
            x-small
            @click="downloadDos(item)"
            :color="colors.primarycolor"
            dark
          >
            ZIP
            <v-icon right>mdi-open-in-new</v-icon>
          </v-btn>
        </template>
        <template v-slot:item.createdBy="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <sea-avatar v-bind="attrs" v-on="on">
                {{
                  getIniziali({
                    nome: item.createdByFirstName,
                    cognome: item.createdByLastName,
                  })
                }}
              </sea-avatar>
            </template>
            {{ item.createdByFirstName }} {{ item.createdByLastName }}
          </v-tooltip>
        </template>
        <template v-slot:item.visibile="{ item }">
          <check-icon :checked="item.visibile"></check-icon>
        </template>
        <template v-slot:item.statoLettura="{ item }">
          <stato-lettura-azienda :stato="item.statoLettura" />
        </template>
        <template v-slot:item.dataConsegna="{ item }">
          {{ item.dataConsegna | dateFormat }}
        </template>
      </v-data-table>
    </template>
  </sea-page-content>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mixin from "@/mixin";
import StatoLetturaAzienda from "@/components/StatoLetturaAzienda.vue";


const states = [
  { text: "Nuovi", active: false, value: 0 },
  { text: "Letti lavoratore", active: false, value: 2 },
  { text: "Letti azienda", active: false, value: 1 },
  { text: "Non letti lavoratore", active: false, value: 20 },
  { text: "Non letti azienda", active: false, value: 10 },
];

const headers = [
  {
    text: "Tag",
    value: "tags",
    sortable: false,
    class: ["heading", "sort"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Titolo",
    value: "nome",
    sortable: false,
    filterable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Data scadenza",
    value: "dataScadenza",
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Pubblicato",
    value: "visibile",
    align: "center",
    sortable: false,
    filterable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Data",
    value: "dataConsegna",
    sortable: false,
    filterable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Da",
    value: "createdBy",
    sortable: false,
    filterable: false,
    align: "center",
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Letto",
    value: "statoLettura",
    align: "center",
    sortable: false,
    filterable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
  {
    text: "Visualizza",
    value: "visualizza",
    sortable: false,
    filterable: false,
    class: ["heading"],
    cellClass: "text-little-2 hand",
  },
];

export default {
  name: "dossiers",
  components: { StatoLetturaAzienda },
  mixins: [mixin],
  data() {
    return {
      pubblicati: null,
      allTags: true,
      states,
      allStates: true,
      headers,
      selectedTags: [],
      selectedStates: [],
      expanded: [],
    };
  },
  methods: {
    sortBy(val) {
      this.headers.forEach((h) => {
        h.class = ["text-little-2"];
        if (h.value === val) h.class.push("sort");
      });
    },
    clicked(value) {
      const index = this.expanded.indexOf(value);
      if (index === -1) {
        this.expanded.length = 0;
        this.expanded.push(value);
      } else {
        this.expanded.splice(index, 1);
      }
    },
    upload() {
      this.$router.push("/company/dossier/lav/new");
    },
    ...mapActions({
      fetchList: "docsAzi/fetchDossiers",
      resetList: "docsAzi/resetDossiers",
      downloadDocument: "docsAzi/downloadDocument",
      downloadDossier: "docsAzi/downloadDossier",
    }),
    cronologia(id) {
      this.$router.push(`/documents/dossierHistory/${id}`);
    },

    resetTags() {
      this.selectedTags = [];
      this.allTags = true;
    },
    downloadDos(item) {
      this.downloadDossier(item);
    },
    download(item) {
      this.downloadDocument(item);
    },
    rowClick: function (_, row) {
      row.select(!row.isSelected);
    },
    addRemove(tag) {
      const index = this.selectedTags.indexOf(tag);
      if (index > -1) {
        this.selectedTags.splice(index, 1);
      } else {
        this.selectedTags.push(tag);
      }
    },
    addRemoveStatus(status) {
      const index = this.selectedStates.indexOf(status);
      if (index > -1) {
        this.selectedStates.splice(index, 1);
      } else {
        this.selectedStates.push(status);
      }
    },
  },
  computed: {
    ...mapGetters({
      items: "docsAzi/dossiers",
      tags: "docsAzi/dossierTags",
    }),

    filteredItems() {
      let out = [...this.items];
      // filtriamo prima sui tag
      out = this.allTags
        ? out
        : out.filter((item) => this.selectedTags.indexOf(item.tags) > -1);
      // poi filtriamo sugli stati
      out = this.allStates
        ? out
        : out.filter(
            (item) =>
              this.selectedStates.indexOf(item.statoLettura) > -1 ||
              (this.selectedStates.indexOf(10) > -1
                ? item.statoLettura !== 1
                : false) ||
              (this.selectedStates.indexOf(20) > -1
                ? item.statoLettura !== 2
                : false)
          );
      //infine per pubblicati o no
      out =
        this.pubblicati === null
          ? out
          : out.filter((item) => item.visibile === this.pubblicati);
      return out;
    },
  },
  watch: {
    selectedTags() {
      if (this.selectedTags.length == 0) {
        this.allTags = true;
        this.tags.forEach((tag) => {
          tag.active = false;
        });
      } else {
        this.allTags = false;
      }
    },
    selectedStates() {
      if (this.selectedStates.length == 0) {
        this.allStates = true;
        this.states.forEach((status) => {
          status.active = false;
        });
      } else {
        this.allStates = false;
      }
    },
  },
};
</script>

<style scoped>
table.detail {
  width: 100%;
  height: 100%;
  border-collapse: collapse;
  margin-bottom: 5px;
}
table.detail td {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  height: 32px;
  padding: 0 16px;
}

table.detail tr:last-child td {
  border: none;
}

table.detail td.center {
  text-align: center;
}
td.expanded-row {
  background-color: #ffff;
  padding: 0 !important;
}
</style>